<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.prenatalConsultations', 2) }} {{nameAndFile}}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-consultation-prenatal',params: { consultation :consultation_id } }" v-if="can">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <template v-if="rows">
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mConsultations"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="prenatals-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mConsultations"
                    >
                        <!-- A virtual compositeumn for actions -->
                        <template slot="action" slot-scope="data">
                            <div class="row" v-if="data.item.isAuthor || hasAdminRole">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-consultation-prenatal', params: { consultation: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.prenatalConsultations', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.typeOfConsultation }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteConsultation(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="prenatals-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "ListPrenatalPerObstetric",
        computed: {
            ...mapGetters(["obstetricConsultation",
                "prenatalConsultations",
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole']),

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },
            nameAndFile:function(){
                let consultationObsetrique = this.obstetricConsultation;
                let dossier = consultationObsetrique.dossier;
                let user = consultationObsetrique.user;
                if (typeof user == 'object' && typeof dossier == 'object'){
                    let nom = user.prenom ? user.prenom+' ' : '' + user.nom ? user.nom :'';
                    return nom+ ' '+ dossier.numero_dossier;
                }
                else{
                    return  "";
                }
            },
            mConsultations: function() {
                let cArray = [];
                _.forEach(this.obstetricConsultation.consultation_prenatales, function(consultation) {
                    let c = {};
                    c.archievedAt = consultation.archieved_at ? moment(consultation.archieved_at).format('DD-MM-YYYY') : ' non archivé' ;
                    c.passedAt = consultation.passed_at ? moment(consultation.passed_at).format('DD-MM-YYYY') : ' non transféré';
                    c.typeOfConsultation = consultation.type_de_consultation;
                    c.complaint = consultation.plaintes;
                    c.antecedentSpouse = consultation.antecedent_conjoint;
                    c.recommendations = consultation.recommandations;
                    c.createdAt = moment(consultation.created_at).format('DD-MM-YYYY HH:mm');
                    c.id = consultation.id;
                    c.slug = consultation.slug;

                    cArray.push(c);
                });

                return cArray;
            },

            rows: function() {
                return this.mConsultations.length;
            }
        },
        data() {
            return {
                consultation_id: this.$route.params.consultation,
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'typeOfConsultation',
                        label: this.$i18n.t('message.typeOfConsultation'),
                        sortable: true
                    },
                    // {
                    //     key: 'complaint',
                    //     label: this.$i18n.tc('message.complaints', 2),
                    // },
                    // {
                    //     key: 'antecedentSpouse',
                    //     label: this.$i18n.t('message.antecedentSpouse'),
                    // },
                    {
                        key: 'recommendations',
                        label: this.$i18n.tc('message.recommendations',2),
                    },
                    // {
                    //     key: 'createdAt',
                    //     label: this.$i18n.t('message.createdAt'),
                    //     sortable: true
                    // },
                    {
                        key: 'archievedAt',
                        label: this.$i18n.t('message.archievedAt'),
                        sortable: true
                    },
                    {
                        key: 'passedAt',
                        label: this.$i18n.t('message.passedAt'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    },

                ],
            }
        },

        methods: {
            getConsultations() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch('getObstetricConsultation', { args : args });

            },

            formattedDisplay (result) {
                return result.numero_grossesse;
            },

            itemSelected(item) {
                this.$router.push({ name: 'consultation-prenatal', params: { consultation: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'consultation-prenatal', params: { consultation: items[0].slug } });
            },

            deleteConsultation(consultation) {
                let self = this;

                let args = {
                    consultation: consultation
                };

                let successMessage = this.$i18n.t('message.prenatalConsultationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };
                this.$store.commit('getPrenatalConsultationsHandler',{prenatalConsultations:this.obstetricConsultation.consultation_prenatales});
                this.$store.dispatch('deletePrenatalConsultation', { args, index: consultation, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + consultation);
                    });
            }
        },

        mounted() {
            // Fetch obstetric consultation list
            this.getConsultations();
        }
    }
</script>

<style scoped>

</style>